/**
 * N5 POS 机相关类型定义
 * 根据 Hyweb ECR API Specification V1.31 文档实现
 */

/**
 * 事件类型枚举 - 定义所有API请求的事件名称
 */
export enum EventName {
  /** 销售请求 */
  SALE = "SALE",
  /** 销售响应 */
  SALE_RESP = "SALE_RESP",
  /** 作废请求 */
  VOID = "VOID",
  /** 作废响应 */
  VOID_RESP = "VOID_RESP",
  /** 退款请求 */
  REFUND = "REFUND",
  /** 退款响应 */
  REFUND_RESP = "REFUND_RESP",
  /** 调整请求 */
  ADJUST = "ADJUST",
  /** 调整响应 */
  ADJUST_RESP = "ADJUST_RESP",
  /** 预授权请求 */
  PREAUTH = "PREAUTH",
  /** 预授权响应 */
  PREAUTH_RESP = "PREAUTH_RESP",
  /** 离线请求 */
  OFFLINE = "OFFLINE",
  /** 离线响应 */
  OFFLINE_RESP = "OFFLINE_RESP",
  /** 分期请求 */
  INSTL = "INSTL",
  /** 分期响应 */
  INSTL_RESP = "INSTL_RESP",
  /** 结算请求 */
  SETTLE = "SETTLE",
  /** 结算响应 */
  SETTLE_RESP = "SETTLE_RESP",
  /** 扫描请求 */
  SCAN = "SCAN",
  /** 扫描响应 */
  SCAN_RESP = "SCAN_RESP",
  /** 交易查询请求 */
  RETRIEVAL = "RETRIEVAL",
  /** 交易查询响应 */
  RETRIEVAL_RESP = "RETRIEVAL_RESP",
  /** 链接测试请求 */
  ECHO = "ECHO",
  /** 链接测试响应 */
  ECHO_RESP = "ECHO_RESP",
  /** 打印请求 */
  PRINT = "PRINT",
  /** 打印响应 */
  PRINT_RESP = "PRINT_RESP",
  /** 中止请求 */
  ABORT = "ABORT",
  /** 中止响应 */
  ABORT_RESP = "ABORT_RESP",
  /** 参数请求 */
  PARAM = "PARAM",
  /** 参数响应 */
  PARAM_RESP = "PARAM_RESP",
  /** 批次查询请求 */
  BATCH_ENQUIRY = "BATCH_ENQUIRY",
  /** 批次查询响应 */
  BATCH_ENQUIRY_RESP = "BATCH_ENQUIRY_RESP",
  /** 结算查询请求 */
  SETTLE_ENQUIRY = "SETTLE_ENQUIRY",
  /** 结算查询响应 */
  SETTLE_ENQUIRY_RESP = "SETTLE_ENQUIRY_RESP",
  /** 汇总查询请求 */
  SUMMARY_ENQUIRY = "SUMMARY_ENQUIRY",
  /** 汇总查询响应 */
  SUMMARY_ENQUIRY_RESP = "SUMMARY_ENQUIRY_RESP",
  /** 创建订单请求 */
  CREATE_ORDER = "CREATE_ORDER",
  /** 创建订单响应 */
  CREATE_ORDER_RESP = "CREATE_ORDER_RESP",
  /** 健康检查请求 */
  HEALTH_CHECK = "HEALTH_CHECK",
  /** 健康检查响应 */
  HEALTH_CHECK_RESP = "HEALTH_CHECK_RESP",
  /** 结算完成请求 */
  SETTLEMENT_COMPLETE = "SETTLEMENT_COMPLETE",
}

/**
 * 支付应用枚举 - 定义支持的支付应用程序
 */
export enum PaymentAppId {
  /** 信用卡 */
  CC = "CC",
  /** QR码/条码支付 (如微信、支付宝、VMJ QR、银联QR) */
  QRC = "QRC",
  /** 优惠券使用 */
  CPN = "CPN",
  /** 美国运通卡 */
  AE = "AE",
  /** 大来卡 (暂不支持) */
  DC = "DC",
  /** 快速支付服务 */
  FPS = "FPS",
  /** 八达通 */
  OPS = "OPS",
  /** 易办事 */
  EPS = "EPS",
  /** 数字人民币 */
  DCEP = "DCEP",
}

/**
 * 支付类型枚举 - 定义具体的支付方式
 */
export enum PaymentType {
  /** Visa卡 */
  VC = "VC",
  /** Visa卡QR */
  VC_QR = "VC-QR",
  /** 万事达卡 */
  MC = "MC",
  /** 万事达卡QR */
  MC_QR = "MC-QR",
  /** JCB卡 */
  JCB = "JCB",
  /** JCB卡QR */
  JCB_QR = "JCB-QR",
  /** 银联 */
  UP = "UP",
  /** 银联QR */
  UP_QR = "UP-QR",
  /** 美国运通卡 */
  AE = "AE",
  /** 支付宝 */
  ALP = "ALP",
  /** 微信支付 */
  WCP = "WCP",
  /** 快速支付服务 */
  FPS = "FPS",
  /** 八达通 */
  OPS = "OPS",
  /** 易办事 */
  EPS = "EPS",
  /** 澳门中银支付 */
  MO_BOCPAY = "MO-BOCPAY",
  /** 大丰支付 */
  TFPAY = "TFPAY",
  /** 极易付 */
  UEPAY = "UEPAY",
  /** 工行e支付 */
  ICBCEPAY = "ICBCEPAY",
  /** 广发银行支付 */
  CGBPAY = "CGBPAY",
  /** 国际银行支付 */
  LUSOPAY = "LUSOPAY",
  /** 澳门通 */
  MPAY = "MPAY",
  /** DCC + Visa卡 */
  DCC_VC = "DCC-VC",
  /** DCC + 万事达卡 */
  DCC_MC = "DCC-MC",
  /** 忠诚度 + 银联 */
  LMS_UP = "LMS-UP",
  /** 忠诚度 + Visa卡 */
  LMS_VC = "LMS-VC",
  /** UPLAN */
  UPLAN = "UPLAN",
}

/**
 * 状态码枚举 - 定义API响应状态码
 */
export enum StatusCode {
  /** 主机批准/接受 */
  APPROVED = "00",
  /** 退款处理中/主机已接受 (仅适用于QRC) */
  REFUND_PROCESSING = "02",
  /** 确认中/处理中 */
  PROCESSING = "03",
  /** 用户取消 */
  CANCELLED = "09",
  /** 主机拒绝 */
  DECLINED = "10",
  /** 用户撤销 (仅适用于微信/支付宝) */
  REVERSED = "11",
  /** 交易已作废/完成/撤销 */
  ALREADY_VOIDED = "12",
  /** 未找到交易 */
  NOT_FOUND = "13",
  /** 不支持的分期方式 */
  TENDER_NOT_SUPPORTED = "14",
  /** 通信/格式错误 */
  COMMUNICATION_ERROR = "90",
  /** 功能或支付类型不支持 */
  NOT_SUPPORTED = "91",
  /** ECR繁忙 */
  ECR_BUSY = "97",
  /** 超时 */
  TIMEOUT = "98",
  /** 未知错误 */
  UNKNOWN_ERROR = "99",
}

/**
 * 交易状态枚举 - 定义交易状态
 */
export enum TransactionStatus {
  /** 主机批准/接受 */
  APPROVED = "A",
  /** 确认中/处理中 */
  PROCESSING = "P",
  /** 已作废 */
  VOIDED = "V",
  /** 已结算 (只有A状态在结算后会变为S) */
  SETTLED = "S",
  /** 拒绝/取消/撤销/操作超时 */
  FAILED = "F",
  /** 八达通读卡超时 */
  OPS_TIMEOUT = "T",
}

/**
 * POS 状态码/交易状态说明映射
 * key 为枚举的值（如 "00"、"09"、"A"、"P"），value 为对应中文说明
 */
export const POS_STATUS_DESC: Record<string, string> = {
  // StatusCode
  [StatusCode.APPROVED]: "主机批准/接受",
  [StatusCode.REFUND_PROCESSING]: "退款处理中/主机已接受 (仅适用于QRC)",
  [StatusCode.PROCESSING]: "确认中/处理中",
  [StatusCode.CANCELLED]: "订单支付已经被取消",
  [StatusCode.DECLINED]: "主机拒绝",
  [StatusCode.REVERSED]: "用户撤销 (仅适用于微信/支付宝)",
  [StatusCode.ALREADY_VOIDED]: "交易已作废/完成/撤销",
  [StatusCode.NOT_FOUND]: "未找到交易",
  [StatusCode.TENDER_NOT_SUPPORTED]: "不支持的分期方式",
  [StatusCode.COMMUNICATION_ERROR]: "二维码格式不支持，交易失败。",
  [StatusCode.NOT_SUPPORTED]: "功能或支付类型不支持",
  [StatusCode.ECR_BUSY]: "ECR繁忙",
  [StatusCode.TIMEOUT]: "超时",
  [StatusCode.UNKNOWN_ERROR]: "未知错误",

  // TransactionStatus
  [TransactionStatus.APPROVED]: "主机批准/接受",
  [TransactionStatus.PROCESSING]: "确认中/处理中",
  [TransactionStatus.VOIDED]: "已作废",
  [TransactionStatus.SETTLED]: "已结算 (只有A状态在结算后会变为S)",
  [TransactionStatus.FAILED]: "拒绝/取消/撤销/操作超时",
  [TransactionStatus.OPS_TIMEOUT]: "八达通读卡超时",
};

export const RESP_CODE_DESC: Record<string, string> = {
  C1057: "不允许持卡人进行的交易，交易被拒绝！",
  C1058: "不允许终端进行的交易，交易被拒绝！",
  C1005: "持卡人认证失败，交易被拒绝！请联系发卡行进行了解。",
  C1051: "银行卡余额不足，交易被拒绝！",
  C1061: "超出取款金額限制，交易被拒绝！",
  C8030: "银行卡余额不足，交易被拒绝！",
  C1045: "發卡行拒絕交易, 請卡戶聯絡發卡行查詢",
  "BUYER_BALANCE_NOT_ENOUGH:BUYER_BALANCE_NOT_ENOUGH": "余额不足，交易被拒绝！",
};

/**
 * 卡类型枚举 - 定义支持的银行卡类型
 */
export enum CardType {
  /** Visa卡 */
  VC = "VC",
  /** 万事达卡 */
  MC = "MC",
  /** JCB卡 */
  JCB = "JCB",
  /** 银联卡 */
  UP = "UP",
  /** 美国运通卡 */
  AE = "AE",
}

/**
 * 进入模式枚举 - 定义卡交易进入方式
 */
export enum EntryMode {
  /** 芯片插入 */
  CHIP = "I",
  /** 非接触式 */
  CONTACTLESS = "C",
  /** 刷卡 */
  SWIPE = "S",
  /** 降级交易 */
  FALLBACK = "F",
  /** QR码 */
  QR = "Q",
  /** 手动输入 */
  MANUAL = "M",
}

/**
 * 忠诚度类型枚举 - 定义优惠券/忠诚度类型
 */
export enum LoyaltyType {
  /** Uplan */
  UP = "UP",
  /** 商户优惠券 */
  MT = "MT",
  /** 银行优惠券 */
  BK = "BK",
  /** LMS */
  LM = "LM",
}

/**
 * 货币代码枚举 - 定义支持的交易货币
 */
export enum CurrencyCode {
  /** 人民币 */
  RMB = "156",
  /** 港币 */
  HKD = "344",
  /** 澳门元 */
  MOP = "446",
  /** 美元 */
  USD = "840",
  /** 柬埔寨瑞尔 */
  KHR = "116",
  /** 老挝基普 */
  LAK = "418",
}

/**
 * 结算类型枚举 - 定义结算报表类型
 */
export enum SettleType {
  /** Visa卡 */
  VC = "VC",
  /** 万事达卡 */
  MC = "MC",
  /** JCB卡 */
  JCB = "JCB",
  /** 银联 */
  UP = "UP",
  /** 银联QR */
  UP_QR = "UP-QR",
  /** 美国运通卡 */
  AE = "AE",
  /** 支付宝 */
  ALP = "ALP",
  /** 微信支付 */
  WCP = "WCP",
  /** 快速支付服务 */
  FPS = "FPS",
  /** 八达通 */
  OPS = "OPS",
  /** 易办事 */
  EPS = "EPS",
  /** DCC + Visa卡 */
  DCC_VC = "DCC-VC",
  /** DCC + 万事达卡 */
  DCC_MC = "DCC-MC",
  /** 忠诚度 + 银联 */
  LMS_UP = "LMS-UP",
  /** 忠诚度 + Visa卡 */
  LMS_VC = "LMS-VC",
  /** UPLAN */
  UPLAN = "UPLAN",
  /** 澳门中银支付 */
  MO_BOCPAY = "MO-BOCPAY",
  /** 大丰支付 */
  TFPAY = "TFPAY",
  /** 极易付 */
  UEPAY = "UEPAY",
  /** 工行e支付 */
  ICBCEPAY = "ICBCEPAY",
  /** 广发银行支付 */
  CGBPAY = "CGBPAY",
  /** 国际银行支付 */
  LUSOPAY = "LUSOPAY",
  /** 澳门通 */
  MPAY = "MPAY",
}

/**
 * 基础请求接口 - 所有API请求的基类
 */
export interface BaseRequest {
  /** 事件名称 */
  EVENT_NAME: EventName;
  /** 交易ID - ECR生成的唯一交易ID，最多32个字符 */
  TXN_ID?: string;
}

/**
 * 基础响应接口 - 所有API响应的基类
 */
export interface BaseResponse {
  /** 事件名称 */
  EVENT_NAME: EventName;
  /** 交易ID - 每个请求定义的唯一交易ID */
  TXN_ID: string;
  /** 状态码 */
  STATUS: StatusCode;
}

/**
 * 金额相关接口 - 包含交易金额的接口
 */
export interface AmountRelated {
  /** 交易金额 (例如: 100.00) */
  TXN_AMT: number;
  /** 小费金额 (如果启用小费功能) */
  TIPS?: number;
}

/**
 * 支付应用相关接口 - 包含支付应用信息的接口
 */
export interface PaymentAppRelated {
  /** 支付应用ID - 参考支付应用列表 */
  PAYMENT_APP_ID?: PaymentAppId;
}

/**
 * 商户参考相关接口 - 包含商户参考信息的接口
 */
export interface MerchantRefRelated {
  /** 商户参考号 - 如果需要在N5小票上打印此参考号，ECR需要发送给N5 */
  MERCHANT_REF?: string;
}

/**
 * 卡信息相关接口 - 包含卡信息的接口
 */
export interface CardInfoRelated {
  /** 卡号 - 用于手动输入进入模式 */
  PAN?: string;
  /** 有效期 - 用于手动输入进入模式 (YYMM格式) */
  EXPIRY_DATE?: string;
  /** 卡类型 */
  CARD_TYPE?: CardType;
}

/**
 * QR码相关接口 - 包含QR码信息的接口
 */
export interface QrCodeRelated {
  /** QR码值 - 对于CC/QRC，是客户呈现的QR码(CPQRC)值 */
  QRC_VALUE?: string;
}

/**
 * 销售请求接口 - 5.1节
 */
export interface SaleRequest
  extends BaseRequest,
    AmountRelated,
    PaymentAppRelated,
    MerchantRefRelated,
    CardInfoRelated,
    QrCodeRelated {
  EVENT_NAME: EventName.SALE;
  /** 打印签名栏 - 是否打印签名栏 */
  PRINT_SS?: boolean;
}

/**
 * 销售响应接口 - 5.2节
 */
export interface SaleResponse extends BaseResponse, AmountRelated {
  EVENT_NAME: EventName.SALE_RESP;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在，是授权响应代码 */
  RESP_CODE?: string;
  /** 忠诚度类型 - 如果使用了优惠券/忠诚度，此字段将返回 */
  LOYALTY_TYPE?: LoyaltyType;
  /** 活动ID - 如果使用了优惠券/忠诚度，相关的活动ID将返回 */
  CAMPAIGN_ID?: string;
  /** 流水号 - 对于CC，是销售小票上的流水号 */
  TRACE_NO: string;
  /** 交易日期 - YYYYMMDD格式 */
  TXN_DATE: string;
  /** 交易时间 - hhmmss格式 */
  TXN_TIME: string;
  /** 主机参考号 - 对于CC，是RRN；对于微信/支付宝，是第三方的交易ID */
  HOST_REF: string;
  /** 优惠券ID - 如果忠诚度类型是UP/MT/BK，应用优惠券ID */
  COUPON_ID?: string;
  /** 授权码 - 仅适用于CC */
  AUTH_CODE?: string;
  /** 授权金额 - 交易金额 + 小费 - 折扣 */
  AUTH_AMT?: number;
  /** 折扣金额 - 如果忠诚度类型有值，应用折扣金额 */
  DISCOUNT?: number;
  /** 本地货币 - 仅适用于DCC & DCEP，交易货币代码如344 */
  LOCAL_CUR?: CurrencyCode;
  /** 外币 - 仅适用于DCC & DCEP，持卡人货币代码如156 */
  FOREIGN_CUR?: CurrencyCode;
  /** 汇率 - 仅适用于DCC & DCEP */
  FXRATE?: number;
  /** 外币金额 - 仅适用于DCC & DCEP，外币交易金额 */
  FOREIGN_AMT?: number;
  /** 商户ID - 对于CC: MID；对于微信/支付宝: sub_mch_id */
  MID: string;
  /** 终端ID - 对于CC: TID；对于微信/支付宝: terminal_id */
  TID: string;
  /** 卡号 - 仅适用于CC，掩码后的卡号 */
  PAN?: string;
  /** 有效期 - 仅适用于CC，掩码后的有效期 (YYMM格式) */
  EXPIRY_DATE?: string;
  /** 忠诚度参考号 - MT/BK: 商户订单号；LM: LMS参考号(12位数字) */
  LOYALTY_REF?: string;

  // 以下字段仅在STATUS = 00 && ECR需要打印收据时返回
  /** 应用标识符 - 仅适用于CC & 美国运通卡 */
  AID?: string;
  /** 批次号 - 仅适用于CC & 美国运通卡 */
  BATCH_NO?: string;
  /** 交易证书 */
  TC?: string;
  /** 应用名称 */
  APP?: string;
  /** 收单机构 */
  ACQUIRER?: string;
  /** 是否需要签名 */
  IF_SIGN?: string;
  /** 卡标签 - 仅适用于CUP卡，信用(C)/借记(D) */
  CARD_TAG?: string;
  /** 卡类型显示 - 仅适用于CC & 美国运通卡，芯片(C)/非接触式(T)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  CARD_TYPE_DISPLAY?: string;
  /** 进入模式显示 - 仅适用于CC & 美国运通卡，芯片(I)/非接触式(C)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  ENTRY_MODE_DISPLAY?: string;
  /** 签名描述 */
  SIGN_DESC?: string;
  /** 交易验证结果 */
  TVR?: string;
  /** 交易状态信息 */
  TSI?: string;
  /** 持卡人姓名 - 仅适用于CC，当APP = VISA/MasterCard/JCB且进入模式不是非接触式时 */
  CARD_HOLDER?: string;
  /** 条款 */
  TERMS?: string;
  /** DCC Visa条款 - 仅适用于DCC，CUP不支持DCC */
  DCC_VISA_TERMS?: string;
  /** DCC商户ID - 仅适用于DCC */
  DCC_MID?: string;
  /** 剩余价值 - 仅适用于OPS */
  REMAINED_VALUE?: string;
  /** 序列号 - 仅适用于OPS */
  SERIAL_NO?: string;
  /** LMS原始余额 - 仅适用于LOYALTY_TYPE=LM，原有LMS积分 */
  LMS_ORIGINAL_BAL?: string;
  /** LMS余额 - 仅适用于LOYALTY_TYPE=LM，结余LMS积分 */
  LMS_BAL?: string;
  /** LMS使用积分 - 仅适用于LOYALTY_TYPE=LM，使用LMS积分 */
  LMS_USED?: string;
  /** LMS批次号 - 仅适用于LOYALTY_TYPE=LM */
  LMS_BATCH_NO?: string;
  /** LMS批准号 - 仅适用于LOYALTY_TYPE=LM */
  LMS_APPRV?: string;
  /** 钱包号 - 仅适用于DCEP */
  WALLET_NO?: string;
}

/**
 * 退款请求接口 - 5.5节
 */
export interface RefundRequest
  extends BaseRequest,
    AmountRelated,
    PaymentAppRelated,
    MerchantRefRelated,
    QrCodeRelated {
  EVENT_NAME: EventName.REFUND;
  QRC_VALUE: string;
  /** 原始交易日期 - 仅适用于UP & UP-QR，原始交易日期 (MMDD格式) */
  TXN_DATE?: string;
  /** 主机参考号 - 仅适用于UP & UP-QR，是RRN */
  HOST_REF?: string;
}

/**
 * 退款响应接口 - 5.6节
 */
export interface RefundResponse extends BaseResponse, AmountRelated {
  EVENT_NAME: EventName.REFUND_RESP;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在，是授权响应代码 */
  RESP_CODE?: string;
  /** 流水号 - 对于CC，是销售小票上的流水号；对于微信/支付宝，是商户交易单号 */
  TRACE_NO: string;
  /** 交易日期 - YYYYMMDD格式 */
  TXN_DATE: string;
  /** 交易时间 - hhmmss格式 */
  TXN_TIME: string;
  /** 主机参考号 - 对于CC，是RRN；对于微信/支付宝，是第三方的交易ID */
  HOST_REF: string;
  /** 授权码 - 仅适用于CC */
  AUTH_CODE?: string;
  /** 本地货币 - 交易货币代码如344；对于DCEP，表示交易货币，仅支持344(HKD) & 156(RMB) */
  LOCAL_CUR?: CurrencyCode;
  /** 外币 - 持卡人货币代码如156；对于DCEP，表示账单货币，仅支持344(HKD) & 156(RMB) */
  FOREIGN_CUR?: CurrencyCode;
  /** 汇率 - 对于DCEP，如果终端配置 */
  FXRATE?: number;
  /** 外币金额 - 外币交易金额；对于DCEP，表示账单金额 */
  FOREIGN_AMT?: number;
  /** 商户ID - 对于CC: MID；对于微信/支付宝: sub_mch_id */
  MID: string;
  /** 终端ID - 对于CC: TID；对于微信/支付宝: terminal_id */
  TID: string;
  /** 卡号 - 仅适用于CC，掩码后的卡号 */
  PAN?: string;
  /** 有效期 - 仅适用于CC，掩码后的有效期 (YYMM格式) */
  EXPIRY_DATE?: string;

  // 以下字段仅在STATUS = 00 && ECR需要打印收据时返回
  /** 应用标识符 - 仅适用于CC & 美国运通卡 */
  AID?: string;
  /** 进入模式显示 - 仅适用于CC & 美国运通卡，芯片(I)/非接触式(C)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  ENTRY_MODE_DISPLAY?: string;
  /** 批次号 - 仅适用于CC & 美国运通卡 */
  BATCH_NO?: string;
  /** 交易证书 */
  TC?: string;
  /** 应用名称 */
  APP?: string;
  /** 收单机构 */
  ACQUIRER?: string;
  /** 持卡人姓名 - 仅适用于CC，当APP = VISA/MasterCard/JCB且进入模式不是非接触式时 */
  CARD_HOLDER?: string;
  /** 钱包号 - 仅适用于DCEP */
  WALLET_NO?: string;
}

/**
 * 作废请求接口 - 5.3节
 */
export interface VoidRequest
  extends Omit<BaseRequest, "TXN_ID">,
    PaymentAppRelated,
    MerchantRefRelated,
    QrCodeRelated {
  EVENT_NAME: EventName.VOID;
  /** 原始交易ID - 对于CC/美国运通卡，此字段是必需的；对于QRC，要么提供TXN_ID，要么提供QRC_VALUE */
  TXN_ID: string;
  /** QR码值 - 仅适用于QRC */
  QRC_VALUE?: string;
}

/**
 * 作废响应接口 - 5.4节
 */
export interface VoidResponse extends BaseResponse {
  EVENT_NAME: EventName.VOID_RESP;
  /** 原始交易ID */
  TXN_ID: string;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在，是授权响应代码 */
  RESP_CODE?: string;
  /** 交易日期 - 作废交易日期 (YYYYMMDD格式) */
  TXN_DATE: string;
  /** 交易时间 - 作废交易时间 (hhmmss格式) */
  TXN_TIME: string;
  /** 主机参考号 - 对于CC，是作废交易的RRN；对于微信/支付宝，是第三方的作废交易ID */
  HOST_REF: string;
  /** 批次号 - 仅适用于CC & 美国运通卡 */
  BATCH_NO?: string;
  /** 商户ID - 对于CC: MID；对于微信/支付宝: sub_mch_id */
  MID: string;
  /** 终端ID - 对于CC: TID；对于微信/支付宝: terminal_id */
  TID: string;
  /** 卡号 - 仅适用于CC，掩码后的卡号 */
  PAN?: string;
  /** 交易金额 */
  TXN_AMT?: number;
  /** 流水号 - 对于CC，是销售小票上的流水号；对于微信/支付宝，是商户交易单号 */
  TRACE_NO: string;
  /** 授权码 - 仅适用于CC */
  AUTH_CODE?: string;
  /** 持卡人姓名 - 仅适用于CC，当APP = VISA/MasterCard/JCB且进入模式不是非接触式时 */
  CARD_HOLDER?: string;
  /** 应用名称 */
  APP?: string;
  /** 收单机构 */
  ACQUIRER?: string;
  /** 条款 */
  TERMS?: string;
  /** DCC Visa条款 - 仅适用于DCC，CUP不支持DCC */
  DCC_VISA_TERMS?: string;
  /** DCC商户ID - 仅适用于DCC */
  DCC_MID?: string;
  /** LMS原始余额 - 仅适用于LOYALTY_TYPE=LM，原有LMS积分 */
  LMS_ORIGINAL_BAL?: string;
  /** LMS余额 - 仅适用于LOYALTY_TYPE=LM，结余LMS积分 */
  LMS_BAL?: string;
  /** LMS使用积分 - 仅适用于LOYALTY_TYPE=LM，使用LMS积分 */
  LMS_USED?: string;
  /** LMS批次号 - 仅适用于LOYALTY_TYPE=LM */
  LMS_BATCH_NO?: string;
  /** LMS批准号 - 仅适用于LOYALTY_TYPE=LM */
  LMS_APPRV?: string;
}

/**
 * 预授权请求接口 - 5.9节
 */
export interface PreauthRequest
  extends BaseRequest,
    AmountRelated,
    PaymentAppRelated,
    MerchantRefRelated,
    CardInfoRelated {
  EVENT_NAME: EventName.PREAUTH;
}

/**
 * 预授权响应接口 - 5.10节
 */
export interface PreauthResponse extends BaseResponse, AmountRelated {
  EVENT_NAME: EventName.PREAUTH_RESP;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在，是授权响应代码 */
  RESP_CODE?: string;
  /** 流水号 - 对于CC，是销售小票上的流水号 */
  TRACE_NO: string;
  /** 交易日期 - YYYYMMDD格式 */
  TXN_DATE: string;
  /** 交易时间 - hhmmss格式 */
  TXN_TIME: string;
  /** 主机参考号 - 对于CC，是RRN */
  HOST_REF: string;
  /** 授权码 - 仅适用于CC */
  AUTH_CODE?: string;
  /** 商户ID - 对于CC: MID */
  MID: string;
  /** 终端ID - 对于CC: TID */
  TID: string;
  /** 卡号 - 仅适用于CC，掩码后的卡号 */
  PAN?: string;
  /** 有效期 - 仅适用于CC，掩码后的有效期 (YYMM格式) */
  EXPIRY_DATE?: string;

  // 以下字段仅在STATUS = 00 && ECR需要打印收据时返回
  /** 应用标识符 - 仅适用于CC & 美国运通卡 */
  AID?: string;
  /** 进入模式显示 - 仅适用于CC & 美国运通卡，芯片(I)/非接触式(C)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  ENTRY_MODE_DISPLAY?: string;
  /** 批次号 - 仅适用于CC & 美国运通卡 */
  BATCH_NO?: string;
  /** 交易证书 */
  TC?: string;
  /** 应用名称 */
  APP?: string;
  /** 收单机构 */
  ACQUIRER?: string;
  /** 是否需要签名 */
  IF_SIGN?: string;
  /** 卡标签 - 仅适用于CUP卡，信用(C)/借记(D) */
  CARD_TAG?: string;
  /** 卡类型显示 - 仅适用于CC & 美国运通卡，芯片(C)/非接触式(T)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  CARD_TYPE_DISPLAY?: string;
  /** 签名描述 */
  SIGN_DESC?: string;
  /** 条款 */
  TERMS?: string;
  /** 持卡人姓名 - 仅适用于CC，当APP = VISA/MasterCard/JCB且进入模式不是非接触式时 */
  CARD_HOLDER?: string;
}

/**
 * 调整请求接口 - 5.7节
 */
export interface AdjustRequest
  extends BaseRequest,
    PaymentAppRelated,
    MerchantRefRelated {
  EVENT_NAME: EventName.ADJUST;
  /** 调整后的总交易金额 - 用于非DCC交易 (应提供其中之一) */
  TOTAL_TXN_AMT?: number;
  /** 调整后的总外币金额 - 用于DCC交易 (应提供其中之一) */
  TOTAL_FOREIGN_AMT?: number;
}

/**
 * 调整响应接口 - 5.8节
 */
export interface AdjustResponse extends BaseResponse, AmountRelated {
  EVENT_NAME: EventName.ADJUST_RESP;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在，是授权响应代码 */
  RESP_CODE?: string;
  /** 忠诚度类型 - 如果使用了优惠券/忠诚度，此字段将返回 */
  LOYALTY_TYPE?: LoyaltyType;
  /** 活动ID - 如果使用了优惠券/忠诚度，相关的活动ID将返回 */
  CAMPAIGN_ID?: string;
  /** 流水号 - 对于CC，是销售小票上的流水号；对于微信/支付宝，是商户交易单号 */
  TRACE_NO: string;
  /** 交易日期 - YYYYMMDD格式 */
  TXN_DATE: string;
  /** 交易时间 - hhmmss格式 */
  TXN_TIME: string;
  /** 主机参考号 - 对于CC，是RRN */
  HOST_REF: string;
  /** 优惠券ID - 如果忠诚度类型是UP/MT/BK，应用优惠券ID */
  COUPON_ID?: string;
  /** 授权码 - 仅适用于CC */
  AUTH_CODE?: string;
  /** 授权金额 - 交易金额 + 小费 - 折扣 */
  AUTH_AMT?: number;
  /** 折扣金额 - 如果忠诚度类型有值，应用折扣金额 */
  DISCOUNT?: number;
  /** 本地货币 - 交易货币代码如344 */
  LOCAL_CUR?: CurrencyCode;
  /** 外币 - 持卡人货币代码如156 */
  FOREIGN_CUR?: CurrencyCode;
  /** 汇率 */
  FXRATE?: number;
  /** 外币金额 - 外币交易金额 */
  FOREIGN_AMT?: number;
  /** 分期方式 - 适用于分期交易 */
  TENDER?: number;
  /** 商户ID - 对于CC: MID；对于微信/支付宝: sub_mch_id */
  MID: string;
  /** 终端ID - 对于CC: TID；对于微信/支付宝: terminal_id */
  TID: string;
  /** 卡号 - 仅适用于CC，掩码后的卡号 */
  PAN?: string;
  /** 有效期 - 仅适用于CC，掩码后的有效期 (YYMM格式) */
  EXPIRY_DATE?: string;
  /** 忠诚度参考号 - MT/BK: 商户订单号；LM: LMS参考号(12位数字) */
  LOYALTY_REF?: string;

  // 以下字段仅在STATUS = 00 && ECR需要打印收据时返回
  /** 应用标识符 - 仅适用于CC & 美国运通卡 */
  AID?: string;
  /** 批次号 - 仅适用于CC & 美国运通卡 */
  BATCH_NO?: string;
  /** 交易证书 */
  TC?: string;
  /** 应用名称 */
  APP?: string;
  /** 收单机构 */
  ACQUIRER?: string;
  /** 是否需要签名 */
  IF_SIGN?: string;
  /** 卡标签 - 仅适用于CUP卡，信用(C)/借记(D) */
  CARD_TAG?: string;
  /** 卡类型显示 - 仅适用于CC & 美国运通卡，芯片(C)/非接触式(T)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  CARD_TYPE_DISPLAY?: string;
  /** 进入模式显示 - 仅适用于CC & 美国运通卡，芯片(I)/非接触式(C)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  ENTRY_MODE_DISPLAY?: string;
  /** 签名描述 */
  SIGN_DESC?: string;
  /** 条款 */
  TERMS?: string;
  /** DCC Visa条款 - 仅适用于DCC，CUP不支持DCC */
  DCC_VISA_TERMS?: string;
  /** 持卡人姓名 - 仅适用于CC，当APP = VISA/MasterCard/JCB且进入模式不是非接触式时 */
  CARD_HOLDER?: string;
}

/**
 * 分期请求接口 - 5.13节
 */
export interface InstallmentRequest
  extends BaseRequest,
    AmountRelated,
    PaymentAppRelated,
    MerchantRefRelated,
    QrCodeRelated {
  EVENT_NAME: EventName.INSTL;
  /** 分期方式/期数 */
  TENDER?: number;
}

/**
 * 分期响应接口 - 5.14节
 */
export interface InstallmentResponse extends BaseResponse, AmountRelated {
  EVENT_NAME: EventName.INSTL_RESP;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在，是授权响应代码 */
  RESP_CODE?: string;
  /** 流水号 - 对于CC，是销售小票上的流水号；对于微信/支付宝，是商户交易单号 */
  TRACE_NO: string;
  /** 交易日期 - YYYYMMDD格式 */
  TXN_DATE: string;
  /** 交易时间 - hhmmss格式 */
  TXN_TIME: string;
  /** 主机参考号 - 对于CC，是RRN */
  HOST_REF: string;
  /** 授权码 - 仅适用于CC */
  AUTH_CODE?: string;
  /** 分期方式/期数 */
  TENDER: number;
  /** 商户ID - 对于CC: MID；对于微信/支付宝: sub_mch_id */
  MID: string;
  /** 终端ID - 对于CC: TID；对于微信/支付宝: terminal_id */
  TID: string;
  /** 卡号 - 仅适用于CC，掩码后的卡号 */
  PAN?: string;
  /** 有效期 - 仅适用于CC，掩码后的有效期 (YYMM格式) */
  EXPIRY_DATE?: string;

  // 以下字段仅在STATUS = 00 && ECR需要打印收据时返回
  /** 应用标识符 - 仅适用于CC & 美国运通卡 */
  AID?: string;
  /** 进入模式显示 - 仅适用于CC & 美国运通卡，芯片(I)/非接触式(C)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  ENTRY_MODE_DISPLAY?: string;
  /** 批次号 - 极适用于CC & 美国运通卡 */
  BATCH_NO?: string;
  /** 交易证书 */
  TC?: string;
  /** 应用名称 */
  APP?: string;
  /** 收单机构 */
  ACQUIRER?: string;
  /** 是否需要签名 */
  IF_SIGN?: string;
  /** 卡标签 - 仅适用于CUP卡，信用(C)/借记(D) */
  CARD_TAG?: string;
  /** 卡类型显示 - 仅适用于CC & 美国运通卡，芯片(C)/非接触式(T)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  CARD_TYPE_DISPLAY?: string;
  /** 签名描述 */
  SIGN_DESC?: string;
  /** 条款 */
  TERMS?: string;
  /** 持卡人姓名 - 仅适用于CC，当APP = VISA/MasterCard/JCB且进入模式不是非接触式时 */
  CARD_HOLDER?: string;
}

/**
 * 结算请求接口 - 5.15节
 */
export interface SettlementRequest extends BaseRequest, MerchantRefRelated {
  EVENT_NAME: EventName.SETTLE;
}

/**
 * 结算响应接口 - 5.16节
 */
export interface SettlementResponse extends BaseResponse {
  EVENT_NAME: EventName.SETTLE_RESP;
}

/**
 * 扫描请求接口 - 5.17节
 */
export interface ScanRequest extends BaseRequest {
  EVENT_NAME: EventName.SCAN;
}

/**
 * 扫描响应接口 - 5.18节
 */
export interface ScanResponse extends BaseResponse {
  EVENT_NAME: EventName.SCAN_RESP;
  /** 扫描到的条码/QR码值 - 仅在STATUS = 00时返回 */
  CODE_VALUE?: string;
}

/**
 * 交易查询请求接口 - 5.19节
 */
export interface RetrievalRequest extends BaseRequest {
  EVENT_NAME: EventName.RETRIEVAL;
}

/**
 * 交易查询响应接口 - 5.20节
 */
export interface RetrievalResponse extends BaseResponse {
  EVENT_NAME: EventName.RETRIEVAL_RESP;
  /** 交易类型 */
  TXN_TYPE?: string;
  /** 交易状态 */
  TXN_STATUS?: TransactionStatus;
  /** 交易金额 (原始) */
  TXN_AMT?: number;
  /** 小费金额 - 如果启用小费功能 */
  TIPS?: number;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在，是授权响应代码 */
  RESP_CODE?: string;
  /** 忠诚度类型 - 如果使用了优惠券/忠诚度，此字段将返回 */
  LOYALTY_TYPE?: LoyaltyType;
  /** 活动ID - 如果使用了优惠券/忠诚度，相关的活动ID将返回 */
  CAMPAIGN_ID?: string;
  /** 流水号 - 对于CC，是销售小票上的流水号；对于微信/支付宝，是商户交易单号 */
  TRACE_NO?: string;
  /** 交易日期 - YYYYMMDD格式 */
  TXN_DATE?: string;
  /** 交易时间 - hhmmss格式 */
  TXN_TIME?: string;
  /** 主机参考号 - 对于CC，是RRN；对于微信/支付宝，是第三方的交易ID */
  HOST_REF?: string;
  /** 优惠券ID - 如果忠诚度类型是UP/MT/BK，应用优惠券ID */
  COUPON_ID?: string;
  /** 授权码 - 仅适用于CC */
  AUTH_CODE?: string;
  /** 分期方式 - 适用于分期交易 */
  TENDER?: number;
  /** 授权金额 - 交易金额 + 小费 - 折扣 */
  AUTH_AMT?: number;
  /** 折扣金额 - 如果忠诚度类型有值，应用折扣金额 */
  DISCOUNT?: number;
  /** 本地货币 - 交易货币代码如344 */
  LOCAL_CUR?: CurrencyCode;
  /** 外币 - 持卡人货币代码如156 */
  FOREIGN_CUR?: CurrencyCode;
  /** 汇率 */
  FXRATE?: number;
  /** 外币金额 - 外币交易金额 */
  FOREIGN_AMT?: number;
  /** 商户ID - 对于CC: MID；对于微信/支付宝: sub_mch_id */
  MID?: string;
  /** 终端ID - 对于CC: TID；对于微信/支付宝: terminal_id */
  TID?: string;
  /** 卡号 - 仅适用于CC，掩码后的卡号 */
  PAN?: string;
  /** 有效期 - 仅适用于CC，掩码后的有效期 (YYMM格式) */
  EXPIRY_DATE?: string;
  /** 忠诚度参考号 - MT/BK: 商户订单号；LM: LMS参考号(12位数字) */
  LOYALTY_REF?: string;

  // 以下字段仅在STATUS = 00 && ECR需要打印收据时返回
  /** 应用标识符 - 仅适用于CC & 美国运通卡 */
  AID?: string;
  /** 批次号 - 仅适用于CC & 美国运通卡 */
  BATCH_NO?: string;
  /** 交易证书 */
  TC?: string;
  /** 收单机构 */
  ACQUIRER?: string;
  /** 是否需要签名 */
  IF_SIGN?: string;
  /** 卡标签 - 仅适用于CUP卡，信用(C)/借记(D) */
  CARD_TAG?: string;
  /** 卡类型显示 - 仅适用于CC & 美国运通卡，芯片(C)/非接触式(T)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  CARD_TYPE_DISPLAY?: string;
  /** 进入模式显示 - 仅适用于CC & 美国运通卡，芯片(I)/非接触式(C)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  ENTRY_MODE_DISPLAY?: string;
  /** 签名描述 */
  SIGN_DESC?: string;
  /** 交易验证结果 */
  TVR?: string;
  /** 交易状态信息 */
  TSI?: string;
  /** 条款 */
  TERMS?: string;
  /** DCC Visa条款 - 仅适用于DCC，CUP不支持DCC */
  DCC_VISA_TERMS?: string;
  /** DCC商户ID - 仅适用于DCC */
  DCC_MID?: string;
  /** 剩余价值 - 仅适用于OPS */
  REMAINED_VALUE?: string;
  /** 序列号 - 极适用于OPS */
  SERIAL_NO?: string;
  /** LMS原始余额 - 仅适用于LOYALTY_TYPE=LM，原有LMS积分 */
  LMS_ORIGINAL_BAL?: string;
  /** LMS余额 - 仅适用于LOYALTY_TYPE=LM，结余LMS积分 */
  LMS_BAL?: string;
  /** LMS使用积分 - 仅适用于LOYALTY_TYPE=LM，使用LMS积分 */
  LMS_USED?: string;
  /** LMS批次号 - 仅适用于LOYALTY_TYPE=LM */
  LMS_BATCH_NO?: string;
  /** LMS批准号 - 仅适用于LOYALTY_TYPE=LM */
  LMS_APPRV?: string;
  /** 钱包号 - 仅适用于DCEP */
  WALLET_NO?: string;
}

/**
 * 链接测试请求接口 - 5.21节
 */
export interface LinkTestRequest {
  EVENT_NAME: EventName.ECHO;
}

/**
 * 链接测试响应接口 - 5.22节
 */
export interface LinkTestResponse extends BaseResponse {
  EVENT_NAME: EventName.ECHO_RESP;
}

/**
 * 打印请求接口 - 5.23节
 */
export interface PrintRequest
  extends Omit<BaseRequest, "TXN_ID">,
    MerchantRefRelated {
  EVENT_NAME: EventName.PRINT;
  /** 原始交易ID - 如果为空，N5将查找最后成功的交易并打印收据 */
  TXN_ID?: string;
  /** 是否重印 */
  IS_REPRINT: boolean;
}

/**
 * 打印响应接口 - 5.24节
 */
export interface PrintResponse extends BaseResponse {
  EVENT_NAME: EventName.PRINT_RESP;
}

/**
 * 中止请求接口 - 5.25节
 */
export interface AbortRequest {
  EVENT_NAME: EventName.ABORT;
}

/**
 * 中止响应接口 - 5.26节
 */
export interface AbortResponse {
  EVENT_NAME: EventName.ABORT_RESP;
  /** 状态码 */
  STATUS: StatusCode;
}

/**
 * 参数请求接口 - 5.27节
 */
export interface ParamsRequest extends BaseRequest {
  EVENT_NAME: EventName.PARAM;
}

/**
 * 参数响应接口 - 5.28节
 */
export interface ParamsResponse extends BaseResponse {
  EVENT_NAME: EventName.PARAM_RESP;
  /** 参数 - JSON字符串 */
  PARAMS?: string;
}

/**
 * 批次查询请求接口 - 5.29节
 */
export interface BatchEnquiryRequest extends BaseRequest {
  EVENT_NAME: EventName.BATCH_ENQUIRY;
  /** 结算日期 - YYYYMMDD格式 */
  SETTLE_DATE: string;
}

/**
 * 批次查询响应接口 - 5.30节
 */
export interface BatchEnquiryResponse extends BaseResponse {
  EVENT_NAME: EventName.BATCH_ENQUIRY_RESP;
  /** 查询结果 */
  RESULT?: string[];
}

/**
 * 结算查询请求接口 - 5.31节
 */
export interface SettleEnquiryRequest extends BaseRequest {
  EVENT_NAME: EventName.SETTLE_ENQUIRY;
  /** 批次ID */
  BATCH_ID: string;
}

/**
 * 结算查询响应接口 - 5.32节
 */
export interface SettleEnquiryResponse extends BaseResponse {
  EVENT_NAME: EventName.SETTLE_ENQUIRY_RESP;
  /** 查询结果 */
  RESULT?: Array<{
    /** 商户ID */
    MID: string;
    /** 终端ID */
    TID: string;
    /** 结算类型 */
    TYPE: SettleType;
    /** 销售笔数 */
    SC: number;
    /** 销售金额 */
    SA: number;
    /** 作废销售笔数 */
    VSC: number;
    /** 作废销售金额 */
    VSA: number;
    /** 退款笔数 */
    RC: number;
    /** 退款金额 */
    RA: number;
    /** 作废退款笔数 */
    VRC: number;
    /** 作废退款金额 */
    VRA: number;
    /** 离线笔数 */
    OC: number;
    /** 离线金额 */
    OA: number;
    /** 作废离线笔数 */
    VOC: number;
    /** 作废离线金额 */
    VOA: number;
  }>;
}

/**
 * 汇总查询请求接口 - 5.33节
 */
export interface SummaryEnquiryRequest extends BaseRequest {
  EVENT_NAME: EventName.SUMMARY_ENQUIRY;
  /** 交易日期范围 - 如果为空，将返回所有未结算交易；否则只返回特定期间的交易 (YYYYMMDD-YYYYMMDD格式) */
  TXN_DATE_START_TO_END?: string;
}

/**
 * 汇总查询响应接口 - 5.34节
 */
export interface SummaryEnquiryResponse extends BaseResponse {
  EVENT_NAME: EventName.SUMMARY_ENQUIRY_RESP;
  /** 查询结果 */
  RESULT?: Array<{
    /** 支付类型 */
    TYPE: PaymentType;
    /** 销售笔数 */
    SC: number;
    /** 销售金额 */
    SA: number;
    /** 作废销售笔数 */
    VSC: number;
    /** 作废销售金额 */
    VSA: number;
    /** 退款笔数 */
    RC: number;
    /** 退款金额 */
    RA: number;
    /** 作废退款笔数 */
    VRC: number;
    /** 作废退款金额 */
    VRA: number;
    /** 离线笔数 */
    OC: number;
    /** 离线金额 */
    OA: number;
    /** 作废离线笔数 */
    VOC: number;
    /** 作废离线金额 */
    VOA: number;
  }>;
}

/**
 * 创建订单请求接口 - 5.35节
 */
export interface CreateOrderRequest extends BaseRequest, AmountRelated {
  EVENT_NAME: EventName.CREATE_ORDER;
  /** 支付应用ID - 仅适用于QRC，此功能用于商户QR */
  PAYMENT_APP_ID: PaymentAppId;
  /** 支付类型 - 支持微信支付、支付宝、银联QR */
  PAYMENT_TYPE: PaymentType;
}

/**
 * 创建订单响应接口 - 5.36节
 */
export interface CreateOrderResponse extends BaseResponse, AmountRelated {
  EVENT_NAME: EventName.CREATE_ORDER_RESP;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在 */
  RESP_CODE?: string;
  /** 商户ID - 对于CC: MID；对于微信/支付宝: sub_mch_id */
  MID: string;
  /** 终端ID - 对于CC: TID；对于微信/支付宝: terminal_id */
  TID: string;
  /** POS序列号 */
  SERIAL_NO: string;
  /** QR码值 */
  QRC_VALUE: string;
}

/**
 * 健康检查请求接口 - 5.37节
 */
export interface HealthCheckRequest extends BaseRequest {
  EVENT_NAME: EventName.HEALTH_CHECK;
}

/**
 * 健康检查响应接口 - 5.38节
 */
export interface HealthCheckResponse extends BaseResponse {
  EVENT_NAME: EventName.HEALTH_CHECK_RESP;
  /** 检查结果 */
  RESULT?: Array<{
    /** 检查项名称 */
    name: string;
    /** 检查URL */
    url: string;
    /** 检查结果 */
    result: string;
  }>;
}

/**
 * 结算完成请求接口 - 5.39节
 */
export interface SettlementCompleteRequest extends BaseRequest {
  EVENT_NAME: EventName.SETTLEMENT_COMPLETE;
}

// 5.40节 - 结算完成响应无响应，POS在收到此请求后将重启

/**
 * 离线请求接口 - 5.11节
 */
export interface OfflineRequest
  extends BaseRequest,
    AmountRelated,
    PaymentAppRelated,
    MerchantRefRelated,
    CardInfoRelated {
  EVENT_NAME: EventName.OFFLINE;
  /** 是否关联原始交易 - 如果值为true，此交易将不会显示读卡页面 */
  RELATED_ORIG_TXN?: boolean;
  /** 原始交易日期 - 原始交易日期 (YYYYMMDD格式)，[对于UP only] */
  ORIG_TXN_DATE?: string;
  /** 授权码 - 对于CC & 美国运通卡，授权码 */
  AUTH_CODE?: string;
}

/**
 * 离线响应接口 - 5.12节
 */
export interface OfflineResponse extends BaseResponse, AmountRelated {
  EVENT_NAME: EventName.OFFLINE_RESP;
  /** 支付类型 */
  PAYMENT_TYPE?: PaymentType;
  /** 响应代码 - 仅在STATUS = 00/10时存在，是授权响应代码 */
  RESP_CODE?: string;
  /** 流水号 - 对于CC，是销售小票上的流水号 */
  TRACE_NO: string;
  /** 交易日期 - YYYYMMDD格式 */
  TXN_DATE: string;
  /** 交易时间 - hhmmss格式 */
  TXN_TIME: string;
  /** 主机参考号 - 对于CC，是RRN */
  HOST_REF: string;
  /** 授权码 - 仅适用于CC */
  AUTH_CODE?: string;
  /** 本地货币 - 交易货币代码如344 */
  LOCAL_CUR?: CurrencyCode;
  /** 外币 - 持卡人货币代码如156 */
  FOREIGN_CUR?: CurrencyCode;
  /** 汇率 */
  FXRATE?: number;
  /** 外币金额 - 外币交易金额 */
  FOREIGN_AMT?: number;
  /** 商户ID - 对于CC: MID；对于微信/支付宝: sub_mch_id */
  MID: string;
  /** 终端ID - 对于CC: TID；对于微信/支付宝: terminal_id */
  TID: string;
  /** 卡号 - 仅适用于CC，掩码后的卡号 */
  PAN?: string;
  /** 有效期 - 仅适用于CC，掩码后的有效期 (YYMM格式) */
  EXPIRY_DATE?: string;

  // 以下字段仅在STATUS = 00 && ECR需要打印收据时返回
  /** 应用标识符 - 仅适用于CC & 美国运通卡 */
  AID?: string;
  /** 进入模式显示 - 仅适用于CC & 美国运通卡，芯片(I)/非接触式(C)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  ENTRY_MODE_DISPLAY?: string;
  /** 批次号 - 仅适用于CC & 美国运通卡 */
  BATCH_NO?: string;
  /** 交易证书 */
  TC?: string;
  /** 应用名称 */
  APP?: string;
  /** 是否需要签名 */
  IF_SIGN?: string;
  /** 收单机构 */
  ACQUIRER?: string;
  /** 卡标签 - 仅适用于CUP卡，信用(C)/借记(D) */
  CARD_TAG?: string;
  /** 卡类型显示 - 仅适用于CC & 美国运通卡，芯片(C)/非接触式(T)/刷卡(S)/降级(F)/QR(Q)/手动(M) */
  CARD_TYPE_DISPLAY?: string;
  /** 签名描述 */
  SIGN_DESC?: string;
  /** 条款 */
  TERMS?: string;
  /** DCC Visa条款 - 仅适用于DCC VISA，如果使用VISA执行DCC销售，此字段将返回 */
  DCC_VISA_TERMS?: string;
  /** 持卡人姓名 - 仅适用于CC，当APP = VISA/MasterCard/JCB且进入模式不是非接触式时 */
  CARD_HOLDER?: string;
}
